import {Component,Fragment} from "react";
class ErrorBoundray extends Component {
    constructor(props){
        super(props);
        this.state = {error: null,errorInfo:null};
    }

    componentDidCatch(error,errorInfo){
        this.setState({
            error:error,
            errorInfo:errorInfo
        })
        console.log(error +" "+ errorInfo);
    }
    render() {
        if(this.state.error)
        {
            return(
                <Fragment>
                 <h2>Something went wrong.</h2>
                 <details  >
                    {this.state.error.toString()}
                    <br />
                    {this.state.errorInfo.componentStack}
             </details> 
             </Fragment>  
            );
                }
          
        return this.props.children;
    }
}
export default ErrorBoundray;